<template>
  <div>
    <HeaderCom />
    <Contact />
    <div id="body">
      <router-view :key="key" />
    </div>
    <MakeAppointment />
    <FooterCom />
  </div>
</template>

<script>
import HeaderCom from "./HeaderCom";
import Contact from "./Contact.vue";
import MakeAppointment from "./MakeAppointment";
import FooterCom from "./FooterCom";

export default {
  name: "layout",
  data() {
    return {
    };
  },
  //组件引入
  components: {
    HeaderCom,
    Contact,
    MakeAppointment,
    FooterCom,
  },
  computed: {
    key() {
      return this.$route.path + Math.random();
    },
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
@import "../assets/less/common";

.burger {
  display: none;
}

//过渡效果
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.low-nav {
  width: 100%;
  // position: absolute;
  left: 0px;
  top: 68px;

  // opacity: 1;
  transition: opacity 0.7s;
  height: 0px;
  background: rgba(0, 0, 0, 0);

  .triangle {
    width: 0px;
    height: 0px;
    *width: 40px;
    *height: 40px;
    font-size: 0;
    line-height: 0;
    overflow: hidden;
    border-width: 10px;
    margin: 0 auto;
    border-style: dashed dashed solid dashed;
    border-color: transparent transparent #ffffff transparent;
  }

  .list {
    width: 100%;
    overflow: hidden;
    background: #ffffff;

    li {
      width: 100%;
      line-height: 54px;
      font-size: 14px;
      text-align: center;
    }

    li:hover {
      background: #4f75c5;
      color: #ffffff !important;
    }
  }
}

.low-nav1 {
  width: 100%;
  height: 260px;

  position: absolute;
  left: 0;
  top: 75px;
  background-color: #eeeeee;

  z-index: 9999999;

  .box {
    height: 100%;
    padding: 50px 0;
    box-sizing: border-box;
    background-image: url(../assets/img/navbg.png);
    background-repeat: no-repeat;
    background-position: right center;
  }

  ul {
    width: 400px;
    margin-left: 300px;

    li {
      width: 50%;
      line-height: 50px;
      cursor: pointer;
    }

    li:hover {
      color: #4f75c5;
    }
  }
}

#header {
  width: 100%;
  height: 76px;
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #ffffff;

  img {
    top: 16px;
    position: absolute;
    left: 20px;
    width: 180px;
    height: 44px;
  }

  .navbar {
    text-align: center;
    //margin-left: 200px;
  }

  .web-ul {
    display: inline-block;

    .first-nav {
      font-size: 16px;
      text-align: center;
      line-height: 76px;
      float: left;
      cursor: pointer;
      position: relative;
      transition: all 0.3s;
      overflow: hidden;
      z-index: 3;

      a {
        color: #4c4c4c;
        display: inline-block;
        font-size: 16px;
        position: relative;
        /* padding-bottom: 15px; */
        padding: 0 35px;
        z-index: 1;
      }

      // a:before {
      //   content: "";
      //   position: absolute;
      //   z-index: -1;
      //   top:100px;
      //   left: 0;
      //   // left: 100%;

      //   height: 100%;
      //   width: 100%;
      //   background: rgba(41, 111, 215, 0.2);
      //   // transition: all .2s;
      //   transition: 0.2s all linear;
      // }
    }

    .first-nav:hover {
      a {
        // font-weight: bold;
        color: @themColor;
        // background-color:rgba(42, 112, 216, .2);
        // transition: background-color .7s;
      }

      // a:before {
      //   width: 100%;
      //   // left: 0;
      //    top: 0;
      // }
    }

    .first-nav.router-link-active {
      font-weight: bold;
      color: @themColor;
      background-color: @activeBackground;
    }

    // .first-nav.active {

    // }
    .first-nav.active a {
      font-weight: bold;
      color: #ffffff;
      background-color: #5076c6;
    }

    .navlow:hover .low-nav {
      // opacity: 1;
      height: 300px;
      transition: height 0.8s;
    }
  }

  .nav-phone-list {
    width: 100%;
    background: #ffffff;
    position: absolute;
    left: 0;
    top: 76px;
    z-index: 999999;
    bottom: 0px;
    border-top: 1px solid #dcdcdc;
    overflow: auto;
    box-sizing: border-box;

    .nav-phone-list-li {
      width: 100%;
      padding: 15px 25px;
      box-sizing: border-box;
      border-bottom: 1px solid #dcdcdc;
      position: relative;

      i {
        position: absolute;
        right: 10px;
        top: 20px;
      }

      ul {
        margin: 20px 0 0 20px;

        li {
          line-height: 35px;
          list-style: disc;
        }
      }
    }
  }
}

@media screen and (max-width: 1160px) {
  .navbar {
    display: none;
  }

  .burger {
    display: block;
  }

  //界面缩小时同时隐藏二级页面
  .low-nav1 {
    display: none;
  }
}

@media screen and (max-width: 1160px) {
  .web-ul {
    display: none;
  }

  .burger {
    display: block;
  }
}

//屏幕大于1300 直接隐藏汉堡及扩展列
@media screen and (min-width: 1160px) {
  .burger {
    display: none;
  }

  .nav-phone-list {
    display: none;
  }

  #header {
    .navbar {
      //text-align: center;
      margin-left: 200px;
    }
  }
}

@media screen and (max-width: 600px) {
  #header {
    img {
      width: 160px;
      top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout.vue